import { render, staticRenderFns } from "./PropertySaleView.vue?vue&type=template&id=581b2cb4&"
import script from "./PropertySaleView.vue?vue&type=script&lang=js&"
export * from "./PropertySaleView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports